import React, { useState } from 'react';
import { color, radius } from '../tokens';
import { haptic } from '../../telegram';

interface ExpertDisclosureProps {
  /** Label for the toggle. Defaults to «Режим эксперта». */
  label?: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const wrap: React.CSSProperties = { marginTop: 16 };
const btnStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: '100%',
  minHeight: 44,
  padding: '10px 12px',
  borderRadius: radius.md,
  background: 'transparent',
  border: `1px dashed ${color.border}`,
  color: color.textMuted,
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
};
const contentStyle: React.CSSProperties = { marginTop: 12 };
const caretBase: React.CSSProperties = { display: 'inline-block', transition: 'transform 0.15s' };

/**
 * Cross-cutting «Режим эксперта / Дополнительно» container. This is THE
 * mechanism that guarantees «ничего не потеряно»: every heavy/technical
 * surface (graph, pipeline form, raw JSON, model/tool settings) mounts here,
 * one tap away, hidden from newcomers by default.
 */
export default function ExpertDisclosure({ label = 'Режим эксперта', children, defaultOpen = false }: ExpertDisclosureProps) {
  const [open, setOpen] = useState(defaultOpen);
  const caret: React.CSSProperties = { ...caretBase, transform: open ? 'rotate(90deg)' : 'none' };
  const toggle = () => { setOpen((v) => !v); haptic('light'); };
  return (
    <div style={wrap}>
      <button type="button" onClick={toggle} aria-expanded={open} style={btnStyle}>
        <span style={caret}>▸</span>
        {label}
      </button>
      {open ? <div style={contentStyle}>{children}</div> : null}
    </div>
  );
}
